export default __webpack_public_path__ + "static/media/photo--lg--74.c4735f62.jpg";